<template>
    <MetaHead></MetaHead>
    <SiteHeader></SiteHeader>
    <slot/>
    <ContactMapForm v-if="$page.props.show_contact_form" :key="$page.props.current_route"></ContactMapForm>
    <SiteFooter></SiteFooter>
</template>

<script>
import MetaHead from "./MetaHead";
import SiteHeader from "./SiteHeader";
import SiteFooter from "./SiteFooter";
import ContactMapForm from "../Components/common/Contact/ContactMapForm";

export default {
    name: "Layout",
    components:{
        MetaHead,
        SiteHeader, SiteFooter, ContactMapForm
    },
}
</script>

<style scoped>

</style>
